"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDesignEvaluationValueDef = exports.isDesignEvaluationKeyDef = exports.greenStyle = exports.blueStyle = exports.greyStyle = exports.greyTitleStyle = void 0;
var lodash_1 = __importDefault(require("lodash"));
var color_1 = require("../../utils/color");
exports.greyTitleStyle = { backgroundColor: color_1.grey.background, justifyContent: 'center' };
exports.greyStyle = { backgroundColor: color_1.grey.background };
exports.blueStyle = { backgroundColor: color_1.lightBlue.background };
exports.greenStyle = { backgroundColor: color_1.lightGreen.background };
function isDesignEvaluationKeyDef(value) {
    return lodash_1.default.has(value, 'key');
}
exports.isDesignEvaluationKeyDef = isDesignEvaluationKeyDef;
function isDesignEvaluationValueDef(value) {
    return lodash_1.default.has(value, 'value');
}
exports.isDesignEvaluationValueDef = isDesignEvaluationValueDef;
//# sourceMappingURL=DesignReportColumn.js.map